module.exports = __webpack_public_path__ + "static/img/Dante-Exum.ec0f2b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dante-Exum.jpg
// module id = q8Sk
// module chunks = 1